<template>
  <div id="#app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
 
}
</script>

<style>
*{
  box-sizing: border-box;
  padding: 0;
  margin: 0;
    -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */

}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh;
  /* padding-top: 8vh; */

}
*::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

.menu-icon {
  display: none; /* 默认不显示图标 */
}
 
/* 小屏幕 (手机) */
@media (max-width: 768px) {
  .mb{
    margin-bottom: 4rem;
  }
}

/* 中等屏幕 (平板) */
@media (min-width: 768px) and (max-width: 992px) {
  .mb{
    margin-bottom: 10rem;
  }
}

/* 大屏幕 (电脑) */
@media (min-width: 992px) {
  .mb{
    margin-bottom: 10rem;
  }
}
</style>
